module.exports = __webpack_public_path__ + "img/honor5.db518edb.png";